export enum SWAGGERHUB_ROLE {
  CONSUMER = 'consumer',
  DESIGNER = 'designer',
  OWNER = 'owner'
}

export enum SubscriptionAuthority {
  ENTERPRISE = 'ENTERPRISE',
  ECOMMERCE = 'ECOMMERCE',
}

export type ShubCoreOrgPreferences = {
  memberSetVisibility: boolean
  memberComment: boolean
  canDesignersShare: boolean
  aiFeaturesEnabled: boolean
}

export type ShubCoreOrgUser = {
  admin: boolean
  blocked: boolean
  licensed: boolean
  organizationRole: SWAGGERHUB_ROLE
}

export type ShubCoreOrgBooleanEntitlement = {
  enabled: boolean
}

export type ShubCoreOrgQuantitativeEntitlement = {
  maximum: number
  available?: number
}

export type ShubCoreOrgEntitlements = {
  'swaggerhub-consumers': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-designers': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-collaborators': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-apis-public': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-apis-private': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-apis-versions': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-apis-total': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-apis-collaborators': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-domains-public': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-domains-private': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-domains-versions': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-domains-total': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-domains-collaborators': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-templates-public': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-templates-private': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-organization-members': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-total-organization-users': ShubCoreOrgQuantitativeEntitlement
  'swaggerhub-comments': ShubCoreOrgBooleanEntitlement
  'swaggerhub-docs-branding': ShubCoreOrgBooleanEntitlement
  'swaggerhub-docs-branding-powered-by-smartbear': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-api-automocking': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-azure-devops-server': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-azure-devops-services': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-azure-gateway': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-azure-api-management': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-aws-lambda': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-aws-gateway': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-apigee': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-bitbucket': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-bitbucket-cloud': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-bitbucket-server': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-explore': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-github': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-github-enterprise': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-gitlab': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-ibm-connect': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-pactflow': ShubCoreOrgBooleanEntitlement
  'swaggerhub-integration-webhook': ShubCoreOrgBooleanEntitlement
  'swaggerhub-permission-designers-make-public': ShubCoreOrgBooleanEntitlement
  'swaggerhub-portal': ShubCoreOrgBooleanEntitlement
  'swaggerhub-portal-trial-button': ShubCoreOrgBooleanEntitlement
  'swaggerhub-projects': ShubCoreOrgBooleanEntitlement
  'swaggerhub-scm-pull': ShubCoreOrgBooleanEntitlement
  'swaggerhub-standardization': ShubCoreOrgBooleanEntitlement
  'swaggerhub-teams': ShubCoreOrgBooleanEntitlement
  'swaggerhub-form-editor': ShubCoreOrgBooleanEntitlement
  'portal-products': ShubCoreOrgQuantitativeEntitlement
  'portal-remove-powered-by-smartbear': ShubCoreOrgBooleanEntitlement
  'portal-edit-subdomain': ShubCoreOrgBooleanEntitlement
  'portal-custom-domain': ShubCoreOrgBooleanEntitlement
  'portal-consumer-side-online': ShubCoreOrgBooleanEntitlement
  'portal-request-access': ShubCoreOrgBooleanEntitlement
  'portal-attachment-manager': ShubCoreOrgBooleanEntitlement
  'portal-ckeditor': ShubCoreOrgBooleanEntitlement
  'swaggerhub-api-mock-request-validation': ShubCoreOrgBooleanEntitlement
}

export type ShubCoreOrgInfo = {
  id: string
  name: string
  displayName?: string
  website?: string
  isDefaultOrg?: boolean
  description?: string
  location?: string
  email: string
  platformManaged: boolean
  preferences?: ShubCoreOrgPreferences
  user?: ShubCoreOrgUser
  entitlements?: ShubCoreOrgEntitlements
  cutoverDate?: string
  createdAt?: string
}

export type ShubCoreOrgSubscription = {
  name: string
  planName: string
  planId: string
  isTrial: boolean
  endDate: string
  totalSeats: number
  usedSeats: number
  subscriptionId: string
  subscriptionAuthority: SubscriptionAuthority
}

export interface ApiHubMeters {
  limit: number
  currentUsage: number
  warningThreshold?: number
}
